import styled from "styled-components";

export const AlertInlineContainer = styled.div`
  overflow: hidden;
  border-top-left-radius: ${({ theme }) => theme.radii.s};
  border-top-right-radius: ${({ theme }) => theme.radii.s};
`;
